import { render, staticRenderFns } from "./ChannelMix.vue?vue&type=template&id=06183e4c&scoped=true"
import script from "./ChannelMix.vue?vue&type=script&lang=js"
export * from "./ChannelMix.vue?vue&type=script&lang=js"
import style0 from "./ChannelMix.vue?vue&type=style&index=0&id=06183e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06183e4c",
  null
  
)

export default component.exports